import React from 'react';
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import { InformedConsentHistoryTableRow } from './InformedConsentHistoryTableRow';

export const InformedConsentHistoryTable = ({ records = [], isLoading }) => {
	return (
		<TableContainer
			component={Paper}
			variant='outlined'
			sx={{
				borderRadius: '8px',
				boxShadow: 'none',
				overflow: 'hidden',
			}}
		>
			<Table
				size='small'
				sx={{
					'& tbody tr:last-of-type td': {
						borderBottom: 'none',
					},
				}}
			>
				<TableHead>
					<TableRow>
						<TableCell>DATE RECEIVED</TableCell>
						<TableCell>COMMENT</TableCell>
						<TableCell>ATTACHMENTS</TableCell>
						<TableCell>STATUS</TableCell>
						<TableCell />
					</TableRow>
				</TableHead>
				<TableBody>
					{isLoading ? (
						<TableRow>
							<TableCell colSpan={5} align='center'>
								<Typography variant='body2' color='text.secondary'>
									Loading history...
								</Typography>
							</TableCell>
						</TableRow>
					) : records.length === 0 ? (
						<TableRow>
							<TableCell colSpan={5} align='center'>
								<Typography variant='body2' color='text.secondary'>
									No informed consent recorded
								</Typography>
							</TableCell>
						</TableRow>
					) : (
						records.map((record) => (
							<InformedConsentHistoryTableRow key={record.id} record={record} />
						))
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
